module.exports = __webpack_public_path__ + "static/media/background-product-feature.91158f08.jpg";